import { Injectable } from '@angular/core';
import { AbstractStorageService } from '@libs/index';
import { STORAGE_KEY } from '@libs/index';
import { CookiesConfig } from '../../models/interfaces/CookiesConfig.interface';
import { GoogleApiPlace } from '@libs/index';
import { UnfinishedBookingData } from '../../models/interfaces/UnfinishedBookingData.interface';
import { StringUtils } from '@libs/index';
import { RwgData } from '../../models/interfaces/RwgData.interface';
import { COUNTRY_CODE } from '@libs/index';
import { StoredReferrer } from '../../models/interfaces/StoredReferrer.interface';

@Injectable({
  providedIn: 'root',
})
export class StorageService extends AbstractStorageService {
  constructor() {
    super();
  }

  //region PLACE ID
  public saveGooglePlace(place: GoogleApiPlace): boolean {
    return this.saveData(STORAGE_KEY.GOOGLE_PLACE, place);
  }

  public getGooglePlace(): GoogleApiPlace {
    return this.getAndParseData(STORAGE_KEY.GOOGLE_PLACE);
  }
  //endregion

  //region COOKIES
  public saveCookiesConfig(cookiesConfig: CookiesConfig): boolean {
    return this.saveData(STORAGE_KEY.COOKIES_CONFIG, cookiesConfig);
  }

  public getCookiesConfig(): CookiesConfig {
    return this.getAndParseData(STORAGE_KEY.COOKIES_CONFIG);
  }
  //endregion

  //region UNFINISHED_BOOKING_DATA
  public saveUnfinishedBookingData(data: UnfinishedBookingData): boolean {
    try {
      return this.saveData(
        STORAGE_KEY.UNFINISHED_BOOKING_DATA,
        StringUtils.encodeBase64(JSON.stringify(data))
      );
    } catch (e) {
      return false;
    }
  }

  public getUnfinishedBookingData(): UnfinishedBookingData {
    try {
      const item = this.getAndParseData(STORAGE_KEY.UNFINISHED_BOOKING_DATA);

      if (!item?.length) {
        return null;
      }

      return JSON.parse(StringUtils.decodeBase64(item));
    } catch (e) {
      return null;
    }
  }

  public removeUnfinishedBookingData(): boolean {
    return this.removeData(STORAGE_KEY.UNFINISHED_BOOKING_DATA);
  }
  //endregion

  //region RWG_DATA
  public saveRwgData(data: RwgData): boolean {
    try {
      return this.saveData(
        STORAGE_KEY.RWG_DATA,
        StringUtils.encodeBase64(JSON.stringify(data))
      );
    } catch (e) {
      return false;
    }
  }

  public getRwgData(): RwgData {
    try {
      const item = this.getAndParseData(STORAGE_KEY.RWG_DATA);

      if (!item?.length) {
        return null;
      }

      return JSON.parse(StringUtils.decodeBase64(item));
    } catch (e) {
      return null;
    }
  }

  public removeRwgData(): boolean {
    return this.removeData(STORAGE_KEY.RWG_DATA);
  }
  //endregion

  //region TOP_SALONS_SELECTED_COUNTRY
  public saveTopSalonsSelectedCountry(countryCode: COUNTRY_CODE): boolean {
    return this.saveData(STORAGE_KEY.TOP_SALONS_SELECTED_COUNTRY, countryCode);
  }

  public getTopSalonsSelectedCountry(): COUNTRY_CODE {
    return this.getAndParseData(STORAGE_KEY.TOP_SALONS_SELECTED_COUNTRY);
  }
  //endregion

  //region REFERRER
  public saveReferrer(referrer: string): boolean {
    return this.saveData(STORAGE_KEY.REFERRER, {
      value: referrer,
      savedAt: Date.now(),
    } as StoredReferrer);
  }

  public getStoredReferrer(): StoredReferrer {
    return this.getAndParseData(STORAGE_KEY.REFERRER);
  }

  public removeReferrer(): boolean {
    return this.removeData(STORAGE_KEY.REFERRER);
  }
  //endregion
}
